/**
 * 配置报价器导航树 Mock 数据
 */
import type { NavTreeNode } from '@/types/common';
import { ROUTE_PATHS } from '@/utils/constants';

/** 配置报价器导航树 */
export const quotationNavTree: NavTreeNode[] = [
  {
    id: 'product-config',
    label: '产品配置',
    icon: 'settings',
    route: '',
    defaultExpanded: true,
    children: [
      {
        id: 'server-storage',
        label: '服务器与存储',
        icon: 'settings',
        route: ROUTE_PATHS.QUOTATION_SERVER_STORAGE,
      },
      {
        id: 'network-devices',
        label: '网络设备',
        icon: 'settings',
        route: ROUTE_PATHS.QUOTATION_NETWORK_DEVICES,
      },
      {
        id: 'security-devices',
        label: '安全设备',
        icon: 'settings',
        route: ROUTE_PATHS.QUOTATION_SECURITY_DEVICES,
      },
      {
        id: 'software-products',
        label: '软件产品',
        icon: 'settings',
        route: ROUTE_PATHS.QUOTATION_SOFTWARE_PRODUCTS,
      },
      {
        id: 'my-orders',
        label: '我的订单',
        icon: 'receipt_long',
        route: ROUTE_PATHS.QUOTATION_MY_ORDERS,
      },
    ],
  },
  {
    id: 'quote-management',
    label: '报价管理',
    icon: 'receipt_long',
    route: '',
    defaultExpanded: true,
    children: [
      {
        id: 'quote-list',
        label: '报价单列表',
        icon: 'receipt_long',
        route: ROUTE_PATHS.QUOTATION_QUOTE_LIST,
      },
      {
        id: 'shared-quotes',
        label: '共享报价单',
        icon: 'receipt_long',
        route: ROUTE_PATHS.QUOTATION_SHARED_QUOTES,
      },
      {
        id: 'quote-templates',
        label: '报价模板',
        icon: 'receipt_long',
        route: ROUTE_PATHS.QUOTATION_QUOTE_TEMPLATES,
      },
    ],
  },
  {
    id: 'recycle-bin',
    label: '回收站',
    icon: 'delete_outline',
    route: '',
    defaultExpanded: true,
    children: [
      {
        id: 'trash',
        label: '已删除报价单',
        icon: 'delete_outline',
        route: ROUTE_PATHS.QUOTATION_TRASH,
      },
      {
        id: 'trash-settings',
        label: '回收站设置',
        icon: 'delete_outline',
        route: ROUTE_PATHS.QUOTATION_TRASH_SETTINGS,
      },
      {
        id: 'restore-history',
        label: '恢复记录',
        icon: 'delete_outline',
        route: ROUTE_PATHS.QUOTATION_RESTORE_HISTORY,
      },
    ],
  },
  {
    id: 'export-center',
    label: '导出中心',
    icon: 'download',
    route: ROUTE_PATHS.QUOTATION_EXPORT_QUOTE,
    children: [
      {
        id: 'export-history',
        label: '导出记录',
        icon: 'history',
        route: ROUTE_PATHS.QUOTATION_EXPORT_HISTORY,
      },
      {
        id: 'export-templates',
        label: '导出模板',
        icon: 'description',
        route: ROUTE_PATHS.QUOTATION_EXPORT_TEMPLATES,
      },
    ],
  },
];
